import React from 'react';

import BuilderComponent from 'components/BuilderComponent/BuilderComponent';
import { Wrapper } from 'components/Layout/Layout';

import { useParams } from 'react-router-dom';

export default function SchoolLandingPage() {
  const { pageId } = useParams();

  const idBuilderPageMap = {
    1: '05917eac79564070a8353e7a87e1666c',
    2: '5409ea9cb9ae4034a0139022a08b1afa',
    3: '5e0961eec27a4db19725d6ee6b2453c7',
    4: '53ead9cc156d48f3bb18ecb810c1e546',
    5: '2639fc3af5604069acd643fed3c3d3e9',
    6: '04cc8e6bab144562b2436c391900a76f',
    7: 'e1e33a5d10f648a0b8c9fb61ee54a54b',
    8: '717b01d0635e4b34ae8a94767ac1bf37',
    9: '635ddaaa1b404aeda7f4ba201948a7b4',
    10: '60fc0fc0b4714553a7c5c216f831b836',
  };

  return (
    <Wrapper>
      <BuilderComponent
        entries={{
          de: idBuilderPageMap[pageId] ?? '13bf419a719f408d876ec321a21eebc7',
          en: idBuilderPageMap[pageId] ?? 'cf2e8b9d21134d86b89f373b74ead7af',
          sv: idBuilderPageMap[pageId] ?? 'aec6c2e0077441db87deecb2ba4d1295',
        }}
      />
    </Wrapper>
  );
}
